import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory } from 'react-router';
import TextCell from './TextCell';
import SortHeaderCell from './SortHeaderCell';
import { Table, Column, Cell } from 'fixed-data-table';
import * as actions from '../redux/actions';
import DataTableUtil from '../DataTableUtil';
import Util from '../Util';
import Storage from '../Storage';
import { SortTypes } from '../Constants';
import {
  KIOSK_TAG,
  DEFAULT_FILTER_OPTION_TAG,
  DEFAULT_FILTER_OPTION_DEPLOYMENTSET_DESIRED,
  DEFAULT_FILTER_OPTION_DEPLOYMENTSET_ACTUAL,
  DEFAULT_FILTER_OPTION_ORGNAME,
  DEFAULT_FILTER_OPTION_OS,
  DEFAULT_FILTER_OPTION_LOCNAME,
  DEFAULT_FILTER_OPTION_ACTIVE,
  DEFAULT_FILTER_OPTION_SERVICE_PRINTAPI,
  DEFAULT_FILTER_OPTION_SERVICE_PAYAPI,
  DEFAULT_FILTER_OPTION_SERVICE_CAPUI,
  DEFAULT_FILTER_OPTION_SERVICE_KIOSKPROBE,
  DEFAULT_FILTER_OPTION_SERVICE_KSKAPI,
  DEFAULT_FILTER_OPTION_SERVICE_CAFEAPI,
  DEFAULT_FILTER_OPTION_SERVICE_HEATWAVE,
  DEFAULT_FILTER_OPTION_SERVICE_CORTEX,
  DEFAULT_FILTER_OPTION_STATUS,
} from '../Constants';
import _ from 'lodash';
import $ from 'jquery';

const DEFAULT_COL_SORT_DIRS = { lastFetchedDateTime: SortTypes.DESC };
const DEFAULT_TABLE_WIDTH = 1400;
const DEFAULT_TABLE_HEIGHT = 500;

function getFilterKey(tableTitle) {
  return tableTitle + '-filterText';
}

function getColSortKey(tableTitle) {
  return tableTitle + '-columnSortDirs';
}

function getTableViewKey() {
  return 'KioskTable : tableView';
}

function getStateObjectKey(tableTitle, keyName) {
  return tableTitle + '-' + keyName;
}

const APP_STATUS = 'app:status';
const CONFIG_CHECK = 'config:check';
const APP_VERSION = 'app:version';
const KIOSK_STATUS = 'kiosk:status';
const KIOSK_PERIPHERAL = 'kiosk:peripheral';
const OTHER = 'other';
const OS = 'OS';
const OTI = 'OTI';

const FILTER_COLUMNS = {
  [APP_STATUS]: [
    'ip',
    'teamviewerClientID',
    'kioskName',
    'kioskType',
    'locationName',
    'orgName',
    'sfecfgServices',
    'kioskHW',
    'sosdbMonitor',
    'sosdbKioskStatus',
    'kskapiMode',
    'payapiCCMode',
    'payapiProcessorsStatus',
    'kskdbTransqueCount',
    'kskdbCCLocalCount',
    'kskdbCCQuarantineCount',
    'sosdbLastFullSync',
    'sosdbLastFullSyncXAgo',
    'lastFetchedDateTime',
    'lastFetchedXAgo',
  ],
  [CONFIG_CHECK]: [
    'ip',
    'teamviewerClientID',
    'kioskName',
    'kioskType',
    'locationName',
    'orgName',
    'capuiDeviceName',
    'locationName',
    'orgName',
    'sosdbLocName',
    'sosdbOrgName',
    'sosdbTimezoneLong',
    'timezoneLong',
    'currentTouchAxis',
    'calibratedTouchAxis',
    'lastFetchedDateTime',
    'lastFetchedXAgo',
  ],
  [APP_VERSION]: [
    'ip',
    'teamviewerClientID',
    'kioskName',
    'kioskType',
    'locationName',
    'orgName',
    'sosdbDeploymentSet',
    'kvsNames',
    'printapiVersion',
    'payapiVersion',
    'capuiVersion',
    'kskapiVersion',
    'cafeapiVersion',
    'heatwaveVersion',
    'linuxdashVer',
    'kioskprobeVersion',
    'sosdbTag',
    'sosdbDeploymentTime',
    'lastFetchedDateTime',
    'lastFetchedXAgo',
  ],
  [KIOSK_STATUS]: [
    'ip',
    'teamviewerClientID',
    'kioskName',
    'kioskType',
    'locationName',
    'orgName',
    'timezone',
    'cpu1MinLoadAvgPercent',
    'cpu5MinLoadAvgPercent',
    'cpu15MinLoadAvgPercent',
    'memUsedPercent',
    'diskUsedPercent',
    'diskTotal',
    'uptime',
    'kioskprobeVersion',
    'kioskprobeRunning',
    'lastFetchedDateTime',
    'lastFetchedXAgo',
  ],
  [KIOSK_PERIPHERAL]: [
    'ip',
    'teamviewerClientID',
    'kioskName',
    'kioskType',
    'locationName',
    'orgName',
    'touchscreenType',
    'kioskTouchDriver',
    'usbBarcodeScanner',
    'kskMSR',
    'usbPrinter',
    'usbScale',
    'usbFingerprintReader',
    'usbBillAcceptor',
    'usbCoinDispenser',
    'usbTemperatureSensor',
    'usbCustomerLineDisplay',
    'lastFetchedDateTime',
    'lastFetchedXAgo',
  ],
  [OTHER]: [
    'ip',
    'teamviewerClientID',
    'kioskName',
    'kioskType',
    'locationName',
    'orgName',
    'hasSosdbKiosk',
    'kskcfgServerUrl',
    'os',
    'fingerprint',
    'kskdbSahCount',
    'kskdbSapCount',
    'kskdbx',
    'salesdbx',
    'ccdbx',
    'sosdbLastTransDate',
    'sosdbLastTranDateXAgo',
    'kioskISOVersion',
    'macAddress',
    'fetchStatus',
    'lastFetchedDateTime',
    'lastFetchedXAgo',
  ],
  [OS]: [
    'ip',
    'teamviewerClientID',
    'kioskName',
    'kioskType',
    'locationName',
    'orgName',
    'kioskHW',
    'osUpToDate',
    'uptime',
    'os',
    'patchDateTime',
    'ciscoampVersion',
    'cortexAgentVersion',
    'lastFetchedDateTime',
    'lastFetchedXAgo',
    'optConnectSerialNumber',
  ],
  [OTI]: [
    'ip',
    'teamviewerClientID',
    'kioskName',
    'locationName',
    'orgName',
    'firmware',
    'config',
    'lastFetchedDateTime',
    'lastFetchedXAgo',
  ],
};

function getHostInfoKey(hostInfo) {
  let key = hostInfo.id || hostInfo.fingerprint || (hostInfo.ip + '-' + hostInfo.macAddress);
  return key;
}

function getTrashIconKey(hostInfo) {
  return 'trash-icon' + '-' + getHostInfoKey(hostInfo);
}

function getRefreshIconKey(hostInfo) {
  return 'refresh-icon' + '-' + getHostInfoKey(hostInfo);
}

class KioskTable extends React.Component {
  constructor(props) {
    super(props);

    let tableView = Storage.getSessionItem(getTableViewKey()) || APP_STATUS;
    let filterText = Storage.getSessionItem(getFilterKey(props.tableTitle)) || '';
    let columnSortDirs =
      Storage.getSessionItem(getColSortKey(props.tableTitle)) || DEFAULT_COL_SORT_DIRS;
    let showMoreFilters =
      Storage.getSessionItem(getStateObjectKey(props.tableTitle, 'showMoreFilters')) || false;
    let selectedFilterObj = Storage.getSessionItem(
      getStateObjectKey(props.tableTitle, 'selectedFilterObj')
    ) || {
      sosdbTag: DEFAULT_FILTER_OPTION_TAG,
      orgName: DEFAULT_FILTER_OPTION_ORGNAME,
      os: DEFAULT_FILTER_OPTION_OS,
      locationName: DEFAULT_FILTER_OPTION_LOCNAME,
      sosdbDeploymentSet: DEFAULT_FILTER_OPTION_DEPLOYMENTSET_DESIRED,
      kvsNames: DEFAULT_FILTER_OPTION_DEPLOYMENTSET_ACTUAL,
      isActive: DEFAULT_FILTER_OPTION_ACTIVE,
      printapiRunning: DEFAULT_FILTER_OPTION_SERVICE_PRINTAPI,
      payapiRunning: DEFAULT_FILTER_OPTION_SERVICE_PAYAPI,
      capuiRunning: DEFAULT_FILTER_OPTION_SERVICE_CAPUI,
      kioskprobeRunning: DEFAULT_FILTER_OPTION_SERVICE_KIOSKPROBE,
      kskapiRunning: DEFAULT_FILTER_OPTION_SERVICE_KSKAPI,
      cafeapiRunning: DEFAULT_FILTER_OPTION_SERVICE_CAFEAPI,
      heatwaveRunning: DEFAULT_FILTER_OPTION_SERVICE_HEATWAVE,
      cortexAgentRunning: DEFAULT_FILTER_OPTION_SERVICE_CORTEX,
      kioskStatus: DEFAULT_FILTER_OPTION_STATUS,
    };

    this.state = {
      tableView: tableView,
      filterText: filterText,
      columnSortDirs: columnSortDirs,
      showSelectedOnly: false,
      showMoreFilters: showMoreFilters,
      selectedFilterObj: selectedFilterObj,
    };

    this.handleSortChange = this.handleSortChange.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.handleClearFilterText = this.handleClearFilterText.bind(this);
    this.handleUpdateSelectedKiosks = this.handleUpdateSelectedKiosks.bind(this);
    this.handleDeleteSelectedKiosks = this.handleDeleteSelectedKiosks.bind(this);
    this.handleBatchAction = this.handleBatchAction.bind(this);
    this.handleTagSelectedKiosks = this.handleTagSelectedKiosks.bind(this);
    this.handleUpdateDeploymentSet = this.handleUpdateDeploymentSet.bind(this);
    this.handleKioskPackageUpdate = this.handleKioskPackageUpdate.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectKiosk = this.handleSelectKiosk.bind(this);
    this.handleShiftSelectKiosk = this.handleShiftSelectKiosk.bind(this);
    this.handleUnselectAll = this.handleUnselectAll.bind(this);
    this.handleToggleBooleanState = this.handleToggleBooleanState.bind(this);
  }

  async componentWillMount() {
    const { dispatch, hostInfoList, selectedHostInfoList } = this.props;

    let hostInfoIdMap = new Map();
    for (let hostInfo of hostInfoList) {
      hostInfoIdMap.set(hostInfo.id, hostInfo.id);
    }

    let extraSelectedList = selectedHostInfoList.filter((hostInfo) => {
      return !hostInfoIdMap.has(hostInfo.id);
    });

    // remove selected host info that are not in current hostInfoList
    // e.g. switching from "Prod Kiosks" to "Test Kiosks" and hostInfo/kiosk
    // selected under Prod will not be available under Test
    extraSelectedList.forEach((hostInfo) => {
      dispatch(actions.unselectHostInfoId(hostInfo.id));
    });
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(actions.updateLastAccessedKiosk(0));
  }

  handleSortChange(columnKey, sortDir) {
    let value = { [columnKey]: sortDir };
    this.setState({ columnSortDirs: value }, () => {
      Storage.setSessionItem(getColSortKey(this.props.tableTitle, this.state.tableView), value);
    });
  }

  handleFilter(e) {
    if (!e.target.value) {
      this.handleClearFilterText();
      return;
    }

    const filterBy = this.refs.filterInput.value;
    this.setState({ filterText: filterBy }, () => {
      Storage.setSessionItem(getFilterKey(this.props.tableTitle), filterBy);
    });
  }

  handleClearFilterText() {
    this.setState({ filterText: '' }, () => {
      Storage.setSessionItem(getFilterKey(this.props.tableTitle), '');
    });
  }

  handleSelectTableView(tableView) {
    let filterText = Storage.getSessionItem(getFilterKey(this.props.tableTitle)) || '';
    let columnSortDirs =
      Storage.getSessionItem(getColSortKey(this.props.tableTitle)) || DEFAULT_COL_SORT_DIRS;
    this.setState(
      {
        tableView: tableView,
        filterText: filterText, // also restore filter text
        columnSortDirs: columnSortDirs, // also restore column sort directions
      },
      () => {
        Storage.setSessionItem(getTableViewKey(), tableView);
      }
    );
  }

  handleViewHostInfo(hostInfo, event) {
    event.stopPropagation();
    // alert(hostInfo.ip);
    browserHistory.push(`/id/${hostInfo.id}/overview`);
  }

  handleRowClick(dataList, event, rowIndex) {
    let kiosk = dataList[rowIndex];

    // disable text selection
    let sel = {};
    if (window.getSelection) {
      sel = window.getSelection();
    } else if (document.selection) {
      sel = document.selection.createRange();
    }
    if (sel.rangeCount) {
      sel.removeAllRanges();
    }
    if (sel.text > '') {
      document.selection.empty();
    }

    // console.log('handleRowClick event.shiftKey=', event.shiftKey, rowIndex, kiosk.ip);

    // select a range of kiosks
    if (event.shiftKey) {
      let { selectedHostInfoList } = this.props;
      let firstIndex = rowIndex;
      for (let i = 0; i < dataList.length; i++) {
        let k = dataList[i];
        for (let selected of selectedHostInfoList) {
          if (k.id === selected.id) {
            firstIndex = i;
            break;
          }
        }
        if (firstIndex !== rowIndex) {
          break;
        }
      }

      let selectedHostInfoIdList = [];
      for (let i = firstIndex; i <= rowIndex; i++) {
        selectedHostInfoIdList.push(dataList[i].id);
      }

      this.handleShiftSelectKiosk(selectedHostInfoIdList);
    } else {
      this.handleSelectKiosk(kiosk);
    }
  }

  handleUnselectAll() {
    const { dispatch } = this.props;
    dispatch(actions.unselectAllHostInfoIdList());
  }

  handleToggleBooleanState(name) {
    let value = this.state[name];
    this.setState({ [name]: !value }, () => {
      Storage.setSessionItem(getStateObjectKey(this.props.tableTitle, name), !value);
    });
  }

  getRowClassNameGetter(dataList, selectedHostInfoList, rowIndex) {
    let row = dataList[rowIndex];
    let isSelected = selectedHostInfoList.find((host) => host.id === row.id);
    let className = isSelected ? 'row-selected' : '';
    // console.log('getRowClassNameGetter', row.ip, className);
    return className;
  }

  handleDeleteRow(hostInfo, ref, event) {
    event.stopPropagation();
    const { dispatch } = this.props;
    let doDelete = confirm(
      '' +
        (hostInfo.kioskName ? 'name: ' + hostInfo.kioskName : '') +
        (hostInfo.kioskType ? '\ntype: ' + hostInfo.kioskType : '') +
        (hostInfo.ip ? '\nipaddr: ' + hostInfo.ip : '') +
        (hostInfo.macAddress ? '\nmacaddress: ' + hostInfo.macAddress : '') +
        (hostInfo.id ? '\nid: ' + hostInfo.id : '') +
        '\nDelete?'
    );
    if (doDelete) {
      let promise = dispatch(actions.deleteHostInfo(hostInfo.id));
      let key = getTrashIconKey(hostInfo);
      let $icon = $(ReactDOM.findDOMNode(ref[key]));
      $icon.addClass('fa-spin');
      $icon.removeClass('animated tada');
      promise
        .then(() => {
          $icon.removeClass('fa-spin');
          $icon.addClass('animated tada');
        })
        .catch((e) => {
          $icon.removeClass('fa-spin');
          $icon.addClass('animated tada');
          alert('Error: Delete failed! ' + e.message); // todo: use alert component
        });
    }
  }

  handleRefreshIconClick(hostInfo, ref, event) {
    event.stopPropagation();
    const { dispatch } = this.props;
    let promise = dispatch(actions.fetchInfo(hostInfo));
    let key = getRefreshIconKey(hostInfo);
    let $icon = $(ReactDOM.findDOMNode(ref[key]));
    $icon.addClass('fa-spin');
    $icon.removeClass('animated tada');
    promise
      .then(() => {
        $icon.removeClass('fa-spin');
        $icon.addClass('animated tada');
      })
      .catch((e) => {
        $icon.removeClass('fa-spin');
        $icon.addClass('animated tada');
        alert('Error: Refresh failed! ' + e.message); // todo: use alert component
      });
  }

  handleUpdateSelectedKiosks() {
    this.props.onUpdateKiosks();
  }

  handleDeleteSelectedKiosks() {
    this.props.onDeleteKiosks();
  }

  handleKioskPackageUpdate() {
    this.props.onKioskPackageUpdate();
  }

  handleBatchAction() {
    this.props.onBatchAction();
  }

  handleTagSelectedKiosks() {
    this.props.onTagKiosks();
  }

  handleUpdateDeploymentSet() {
    this.props.onUpdateDeploymentSet();
  }

  // https://facebook.github.io/react/docs/forms.html
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    if (name.indexOf('.') !== -1) {
      let objName = name.split(/\./)[0];
      let keyName = name.split(/\./)[1];
      let obj = { ...this.state[objName] };
      obj[keyName] = value;
      this.setState(
        {
          [objName]: obj,
        },
        () => {
          Storage.setSessionItem(getStateObjectKey(this.props.tableTitle, objName), obj);
        }
      );
    } else {
      this.setState(
        {
          [name]: value,
        },
        () => {
          Storage.setSessionItem(getStateObjectKey(this.props.tableTitle, name), value);
        }
      );
    }
  }

  handleSelectKiosk(hostInfo, toggle = true) {
    const { dispatch, selectedHostInfoIdList } = this.props;
    let selected = _.includes(selectedHostInfoIdList, hostInfo.id);
    if (toggle && selected) {
      dispatch(actions.unselectHostInfoId(hostInfo.id));
    } else {
      dispatch(actions.selectedHostInfoId(hostInfo.id));
    }
  }

  handleShiftSelectKiosk(hostInfoIdList) {
    const { dispatch } = this.props;
    dispatch(actions.selectedHostInfoIdList(hostInfoIdList));
  }

  render() {
    const { columnSortDirs, tableView, showSelectedOnly, showMoreFilters, selectedFilterObj } =
      this.state;
    const {
      hostInfoList,
      selectedHostInfoList,
      kskTagSelectOptions,
      kskOrgNameSelectOptions,
      kskOsNameSelectOptions,
      kskLocNameSelectOptions,
      kskDeploymentSetSelectOptions,
      kvsNamesSelectOptions,
      kskActiveSelectOptions,
      kskStatusSelectOptions,
      servicePrintapiSelectOptions,
      servicePayapiSelectOptions,
      serviceCapuiSelectOptions,
      serviceKioskprobeSelectOptions,
      serviceKskapiSelectOptions,
      serviceCafeapiSelectOptions,
      serviceHeatwaveSelectOptions,
      location,
    } = this.props;
    let filterText = this.state.filterText;
    if (filterText !== undefined || filterText !== null) {
      // make sure it is string and not number type, so _.isEmpty will work correctly
      filterText = String(filterText);
    }

    const filterSelected = showSelectedOnly && selectedHostInfoList.length > 0;
    const hasFilterText = !_.isEmpty(filterText);
    const isAppVersionTableView = APP_VERSION === tableView;
    const isAppStatusTableView = APP_STATUS === tableView;
    const shouldFilterByTag =
      isAppVersionTableView && selectedFilterObj.sosdbTag !== DEFAULT_FILTER_OPTION_TAG;
    const shouldFilterByDeploymentSet =
      showMoreFilters &&
      isAppVersionTableView &&
      selectedFilterObj.sosdbDeploymentSet !== DEFAULT_FILTER_OPTION_DEPLOYMENTSET_DESIRED;
    const shouldFilterByKvsNames =
      showMoreFilters &&
      isAppVersionTableView &&
      selectedFilterObj.kvsNames !== DEFAULT_FILTER_OPTION_DEPLOYMENTSET_ACTUAL;
    const shouldFilterByOrgName =
      showMoreFilters && selectedFilterObj.orgName !== DEFAULT_FILTER_OPTION_ORGNAME;
    const shouldFilterByOsName =
      showMoreFilters && selectedFilterObj.os !== DEFAULT_FILTER_OPTION_OS;
    const shouldFilterByLocName =
      showMoreFilters && selectedFilterObj.locationName !== DEFAULT_FILTER_OPTION_LOCNAME;
    const shouldFilterByActive = selectedFilterObj.isActive !== DEFAULT_FILTER_OPTION_ACTIVE;

    const shouldFilterByServicePrintapiRunning =
      showMoreFilters &&
      isAppVersionTableView &&
      selectedFilterObj.printapiRunning !== DEFAULT_FILTER_OPTION_SERVICE_PRINTAPI;
    const shouldFilterByServicePayapiRunning =
      showMoreFilters &&
      isAppVersionTableView &&
      selectedFilterObj.payapiRunning !== DEFAULT_FILTER_OPTION_SERVICE_PAYAPI;
    const shouldFilterByServiceCapuiRunning =
      showMoreFilters &&
      isAppVersionTableView &&
      selectedFilterObj.capuiRunning !== DEFAULT_FILTER_OPTION_SERVICE_CAPUI;
    const shouldFilterByServiceKioskprobeRunning =
      showMoreFilters &&
      isAppVersionTableView &&
      selectedFilterObj.kioskprobeRunning !== DEFAULT_FILTER_OPTION_SERVICE_KIOSKPROBE;
    const shouldFilterByServiceKskapiRunning =
      showMoreFilters &&
      isAppVersionTableView &&
      selectedFilterObj.kskapiRunning !== DEFAULT_FILTER_OPTION_SERVICE_KSKAPI;
    const shouldFilterByServiceCafeapiRunning =
      showMoreFilters &&
      isAppVersionTableView &&
      selectedFilterObj.cafeapiRunning !== DEFAULT_FILTER_OPTION_SERVICE_CAFEAPI;
    const shouldFilterByServiceHeatwaveRunning =
      showMoreFilters &&
      isAppVersionTableView &&
      selectedFilterObj.heatwaveRunning !== DEFAULT_FILTER_OPTION_SERVICE_HEATWAVE;
    const shouldFilterByServiceCortexAgentRunning =
      showMoreFilters &&
      isAppVersionTableView &&
      selectedFilterObj.cortexAgentRunning !== DEFAULT_FILTER_OPTION_SERVICE_CORTEX;
    const shouldFilterByKioskStatus =
      showMoreFilters &&
      isAppStatusTableView &&
      selectedFilterObj.kioskStatus !== DEFAULT_FILTER_OPTION_STATUS;

    let {auth: {user}, isProdKioskTable} = this.props;
    // hide ability to add/remove host for front level support role
    let isFrontLevelSupport = user.isFrontLevelSupportRole();
    let isSuperRole = user.isSuperRole();

    const size = hostInfoList.length;
    let dataList = hostInfoList;
    if (filterSelected) {
      dataList = selectedHostInfoList;
    }
    if (shouldFilterByTag) {
      if (_.isEmpty(selectedFilterObj.sosdbTag)) {
        dataList = DataTableUtil.filterList(
          dataList,
          '',
          ['sosdbTag'],
          columnSortDirs,
          null,
          true
        );
      } else {
        dataList = DataTableUtil.filterList(
          dataList,
          selectedFilterObj.sosdbTag,
          ['sosdbTag'],
          columnSortDirs,
          Util.createRegexpExactMatch(selectedFilterObj.sosdbTag)
        );
      }
    }
    if (shouldFilterByDeploymentSet) {
      if (_.isEmpty(selectedFilterObj.sosdbDeploymentSet)) {
        dataList = DataTableUtil.filterList(
          dataList,
          '',
          ['sosdbDeploymentSet'],
          columnSortDirs,
          null,
          true
        );
      } else {
        dataList = DataTableUtil.filterList(
          dataList,
          selectedFilterObj.sosdbDeploymentSet,
          ['sosdbDeploymentSet'],
          columnSortDirs,
          Util.createRegexpExactMatch(selectedFilterObj.sosdbDeploymentSet)
        );
      }
    }
    if (shouldFilterByKvsNames) {
      dataList = DataTableUtil.filterList(
        dataList,
        selectedFilterObj.kvsNames,
        ['kvsNames'],
        columnSortDirs,
        Util.createRegexpExactMatch(selectedFilterObj.kvsNames)
      );
    }

    if (shouldFilterByOsName) {
      dataList = DataTableUtil.filterList(
        dataList,
        selectedFilterObj.os,
        ['os'],
        columnSortDirs,
        Util.createRegexpExactMatch(selectedFilterObj.os)
      );
    }

    if (shouldFilterByOrgName) {
      dataList = DataTableUtil.filterList(
        dataList,
        selectedFilterObj.orgName,
        ['orgName'],
        columnSortDirs,
        Util.createRegexpExactMatch(selectedFilterObj.orgName)
      );
    }
    if (shouldFilterByLocName) {
      dataList = DataTableUtil.filterList(
        dataList,
        selectedFilterObj.locationName,
        ['locationName'],
        columnSortDirs,
        Util.createRegexpExactMatch(selectedFilterObj.locationName)
      );
    }
    if (shouldFilterByActive) {
      let text = String(selectedFilterObj.isActive);

      dataList = DataTableUtil.filterList(
        dataList,
        text,
        ['isActive'],
        columnSortDirs,
        Util.createRegexpExactMatch(text)
      );
    }
    if (shouldFilterByServicePayapiRunning) {
      let text = String(selectedFilterObj.payapiRunning);

      dataList = DataTableUtil.filterList(
        dataList,
        text,
        ['payapiRunning'],
        columnSortDirs,
        Util.createRegexpExactMatch(text)
      );
    }
    if (shouldFilterByServicePrintapiRunning) {
      let text = String(selectedFilterObj.printapiRunning);

      dataList = DataTableUtil.filterList(
        dataList,
        text,
        ['printapiRunning'],
        columnSortDirs,
        Util.createRegexpExactMatch(text)
      );
    }
    if (shouldFilterByServiceCapuiRunning) {
      let text = String(selectedFilterObj.capuiRunning);

      dataList = DataTableUtil.filterList(
        dataList,
        text,
        ['capuiRunning'],
        columnSortDirs,
        Util.createRegexpExactMatch(text)
      );
    }
    if (shouldFilterByServiceKioskprobeRunning) {
      let text = String(selectedFilterObj.kioskprobeRunning);

      dataList = DataTableUtil.filterList(
        dataList,
        text,
        ['kioskprobeRunning'],
        columnSortDirs,
        Util.createRegexpExactMatch(text)
      );
    }
    if (shouldFilterByServiceKskapiRunning) {
      let text = String(selectedFilterObj.kskapiRunning);

      dataList = DataTableUtil.filterList(
        dataList,
        text,
        ['kskapiRunning'],
        columnSortDirs,
        Util.createRegexpExactMatch(text)
      );
    }
    if (shouldFilterByServiceCafeapiRunning) {
      let text = String(selectedFilterObj.cafeapiRunning);

      dataList = DataTableUtil.filterList(
        dataList,
        text,
        ['cafeapiRunning'],
        columnSortDirs,
        Util.createRegexpExactMatch(text)
      );
    }
    if (shouldFilterByServiceHeatwaveRunning) {
      let text = String(selectedFilterObj.heatwaveRunning);

      dataList = DataTableUtil.filterList(
        dataList,
        text,
        ['heatwaveRunning'],
        columnSortDirs,
        Util.createRegexpExactMatch(text)
      );
    }
    if (shouldFilterByServiceCortexAgentRunning) {
      let text = String(selectedFilterObj.cortexAgentRunning);

      dataList = DataTableUtil.filterList(
        dataList,
        text,
        ['cortexAgentRunning'],
        columnSortDirs,
        Util.createRegexpExactMatch(text)
      );
    }
    if (shouldFilterByKioskStatus) {
      let text = String(selectedFilterObj.kioskStatus);

      dataList = DataTableUtil.filterList(
        dataList,
        text,
        ['sosdbKioskStatus'],
        columnSortDirs,
        Util.createRegexpExactMatch(text)
      );
    }
    dataList = DataTableUtil.filterList(
      dataList,
      filterText,
      FILTER_COLUMNS[tableView],
      columnSortDirs
    );

    const hasFilter =
      hasFilterText ||
      shouldFilterByTag ||
      shouldFilterByOrgName ||
      shouldFilterByOsName ||
      shouldFilterByLocName ||
      shouldFilterByDeploymentSet ||
      shouldFilterByKvsNames ||
      shouldFilterByActive ||
      shouldFilterByServicePrintapiRunning ||
      shouldFilterByServicePayapiRunning ||
      shouldFilterByServiceCapuiRunning ||
      shouldFilterByServiceKioskprobeRunning ||
      shouldFilterByServiceKskapiRunning ||
      shouldFilterByServiceCafeapiRunning ||
      shouldFilterByServiceHeatwaveRunning ||
      shouldFilterByServiceCortexAgentRunning ||
      shouldFilterByKioskStatus ||
      dataList.length < size;

    let showDeleteIcon =
      !isFrontLevelSupport &&
      tableView !== APP_STATUS &&
      tableView !== APP_VERSION &&
      tableView !== CONFIG_CHECK;

    // console.log(this.props.tableTitle + ' render: ' + new Date().toLocaleString());
    const tableWidth = this.props.tableWidth || DEFAULT_TABLE_WIDTH;
    const tableHeight = this.props.tableHeight || DEFAULT_TABLE_HEIGHT;

    let ref = {}; // for ref callback to get icon

    // Identifying row of last kiosk accessed by user in Dashweb, save to previousKioskRow
    // if no appropriate matches are found, previousKioskRow will be -1 and the table will be rendered from the top

    let lastAccessedKiosk = this.props.lastAccessedKiosk;
    let tableProps = {};

    if (lastAccessedKiosk) {
      let kiosk = dataList.find((hostInfo) => hostInfo.id === lastAccessedKiosk);
      let previousKioskRow = dataList.indexOf(kiosk);
      tableProps = {
        [previousKioskRow !== -1 ? 'scrollToRow' : 'doNothing']: previousKioskRow,
      };
    }

    return (
      <div className={'kioskTable ' + tableView.replace(/[^a-zA-Z]/g, '_')}>
        <div style={{ display: 'block', margin: '20px auto', width: tableWidth }}>
          <div style={{ textAlign: 'right', marginTop: '-20px', marginBottom: '3px' }}>
            <a
              href='javascript:void(0)'
              onClick={this.handleToggleBooleanState.bind(this, 'showMoreFilters')}
            >
              More Filters:
            </a>
            <input
              style={{ marginLeft: '5px' }}
              name='showMoreFilters'
              type='checkbox'
              checked={showMoreFilters}
              onChange={this.handleInputChange}
            />
          </div>

          <div className='pure-g pure-u-1 card-label button-tetriary'>
            <div className='button-title'>
              <a
                className={tableView === APP_STATUS ? 'tableview tableview-selected' : 'tableview'}
                onClick={this.handleSelectTableView.bind(this, APP_STATUS)}
              >
                {APP_STATUS}
              </a>
              <a
                className={
                  tableView === CONFIG_CHECK ? 'tableview tableview-selected' : 'tableview'
                }
                onClick={this.handleSelectTableView.bind(this, CONFIG_CHECK)}
              >
                {CONFIG_CHECK}
              </a>
              <a
                className={tableView === APP_VERSION ? 'tableview tableview-selected' : 'tableview'}
                onClick={this.handleSelectTableView.bind(this, APP_VERSION)}
              >
                {APP_VERSION}
              </a>
              <a
                className={
                  tableView === KIOSK_STATUS ? 'tableview tableview-selected' : 'tableview'
                }
                onClick={this.handleSelectTableView.bind(this, KIOSK_STATUS)}
              >
                {KIOSK_STATUS}
              </a>
              <a
                className={
                  tableView === KIOSK_PERIPHERAL ? 'tableview tableview-selected' : 'tableview'
                }
                onClick={this.handleSelectTableView.bind(this, KIOSK_PERIPHERAL)}
              >
                {KIOSK_PERIPHERAL}
              </a>
              <a
                className={tableView === OTHER ? 'tableview tableview-selected' : 'tableview'}
                onClick={this.handleSelectTableView.bind(this, OTHER)}
              >
                {OTHER}
              </a>
              <a
                className={tableView === OS ? 'tableview tableview-selected' : 'tableview'}
                onClick={this.handleSelectTableView.bind(this, OS)}
              >
                {OS}
              </a>
              <a
                className={tableView === OTI ? 'tableview tableview-selected' : 'tableview'}
                onClick={this.handleSelectTableView.bind(this, OTI)}
              >
                {OTI}
              </a>
            </div>

            <div style={{ marginLeft: '600px' }}>
              <i className='fa fa-fw fa-desktop' />
              {this.props.tableTitle}
              <select
                style={{ opacity: filterSelected ? '0.4' : 1 }}
                disabled={filterSelected}
                className={'select-filter filter-on'}
                name='selectedFilterObj.isActive'
                value={selectedFilterObj.isActive}
                onChange={this.handleInputChange}
              >
                {kskActiveSelectOptions.map((item) => (
                  <option key={item.key} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>

            <input
              style={{ opacity: filterSelected ? '0.4' : 1 }}
              disabled={filterSelected}
              className={filterText ? 'kiosk-search filter-on' : 'kiosk-search'}
              type='search'
              placeholder='Search'
              ref='filterInput'
              value={filterText}
              onChange={this.handleFilter}
            />
            {filterText && (
              <span
                className='kiosk-search-clear fa fa-fw fa-times-circle'
                onClick={this.handleClearFilterText}
              />
            )}
          </div>

          {showMoreFilters && (
            <div
              className='pure-g pure-u-1 card-sub-label'
              style={{ opacity: filterSelected ? '0.4' : 1 }}
            >
              <select
                style={{ opacity: filterSelected ? '0.4' : 1 }}
                disabled={filterSelected}
                className={shouldFilterByOrgName ? 'select-filter filter-on' : 'select-filter'}
                name='selectedFilterObj.orgName'
                value={selectedFilterObj.orgName}
                onChange={this.handleInputChange}
              >
                {kskOrgNameSelectOptions.map((obj) => (
                  <option key={obj.value} value={obj.value}>
                    {obj.label}
                  </option>
                ))}
              </select>

              <select
                style={{ opacity: filterSelected ? '0.4' : 1 }}
                disabled={filterSelected}
                className={shouldFilterByOsName ? 'select-filter filter-on' : 'select-filter'}
                name='selectedFilterObj.os'
                value={selectedFilterObj.os}
                onChange={this.handleInputChange}
              >
                {kskOsNameSelectOptions.map((obj) => (
                  <option key={obj.value} value={obj.value}>
                    {obj.label}
                  </option>
                ))}
              </select>

              <select
                style={{ opacity: filterSelected ? '0.4' : 1 }}
                disabled={filterSelected}
                className={shouldFilterByLocName ? 'select-filter filter-on' : 'select-filter'}
                name='selectedFilterObj.locationName'
                value={selectedFilterObj.locationName}
                onChange={this.handleInputChange}
              >
                {kskLocNameSelectOptions.map((obj) => (
                  <option key={obj.value} value={obj.value}>
                    {obj.label}
                  </option>
                ))}
              </select>

              <select
                style={{ opacity: filterSelected ? '0.4' : 1 }}
                disabled={filterSelected}
                className={shouldFilterByKioskStatus ? 'select-filter filter-on' : 'select-filter'}
                name='selectedFilterObj.kioskStatus'
                value={selectedFilterObj.kioskStatus}
                onChange={this.handleInputChange}
              >
                {kskStatusSelectOptions.map((obj) => (
                  <option key={obj.value} value={obj.value}>
                    {obj.label}
                  </option>
                ))}
              </select>

              {location.pathname === '/kiosk/adm' && tableView === APP_VERSION && (
                <div>
                  <div>
                    <select
                      style={{ opacity: filterSelected ? '0.4' : 1 }}
                      disabled={filterSelected}
                      className={
                        shouldFilterByDeploymentSet ? 'select-filter filter-on' : 'select-filter'
                      }
                      name='selectedFilterObj.sosdbDeploymentSet'
                      value={selectedFilterObj.sosdbDeploymentSet}
                      onChange={this.handleInputChange}
                    >
                      {kskDeploymentSetSelectOptions.map((item) => (
                        <option key={item.key} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                    <select
                      style={{ opacity: filterSelected ? '0.4' : 1 }}
                      disabled={filterSelected}
                      className={
                        shouldFilterByKvsNames ? 'select-filter filter-on' : 'select-filter'
                      }
                      name='selectedFilterObj.kvsNames'
                      value={selectedFilterObj.kvsNames}
                      onChange={this.handleInputChange}
                    >
                      {kvsNamesSelectOptions.map((item) => (
                        <option key={item.key} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                    <select
                      style={{ opacity: filterSelected ? '0.4' : 1 }}
                      disabled={filterSelected}
                      className={shouldFilterByTag ? 'select-filter filter-on' : 'select-filter'}
                      name='selectedFilterObj.sosdbTag'
                      value={selectedFilterObj.sosdbTag}
                      onChange={this.handleInputChange}
                    >
                      {kskTagSelectOptions.map((item) => (
                        <option key={item.key} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <select
                      style={{ opacity: filterSelected ? '0.4' : 1 }}
                      disabled={filterSelected}
                      className={
                        shouldFilterByServicePrintapiRunning
                          ? 'select-filter filter-on'
                          : 'select-filter'
                      }
                      name='selectedFilterObj.printapiRunning'
                      value={selectedFilterObj.printapiRunning}
                      onChange={this.handleInputChange}
                    >
                      {servicePrintapiSelectOptions.map((item) => (
                        <option key={item.key} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                    <select
                      style={{ opacity: filterSelected ? '0.4' : 1 }}
                      disabled={filterSelected}
                      className={
                        shouldFilterByServicePayapiRunning
                          ? 'select-filter filter-on'
                          : 'select-filter'
                      }
                      name='selectedFilterObj.payapiRunning'
                      value={selectedFilterObj.payapiRunning}
                      onChange={this.handleInputChange}
                    >
                      {servicePayapiSelectOptions.map((item) => (
                        <option key={item.key} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                    <select
                      style={{ opacity: filterSelected ? '0.4' : 1 }}
                      disabled={filterSelected}
                      className={
                        shouldFilterByServiceCapuiRunning
                          ? 'select-filter filter-on'
                          : 'select-filter'
                      }
                      name='selectedFilterObj.capuiRunning'
                      value={selectedFilterObj.capuiRunning}
                      onChange={this.handleInputChange}
                    >
                      {serviceCapuiSelectOptions.map((item) => (
                        <option key={item.key} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                    <select
                      style={{ opacity: filterSelected ? '0.4' : 1 }}
                      disabled={filterSelected}
                      className={
                        shouldFilterByServiceKioskprobeRunning
                          ? 'select-filter filter-on'
                          : 'select-filter'
                      }
                      name='selectedFilterObj.kioskprobeRunning'
                      value={selectedFilterObj.kioskprobeRunning}
                      onChange={this.handleInputChange}
                    >
                      {serviceKioskprobeSelectOptions.map((item) => (
                        <option key={item.key} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                    <select
                      style={{ opacity: filterSelected ? '0.4' : 1 }}
                      disabled={filterSelected}
                      className={
                        shouldFilterByServiceKskapiRunning
                          ? 'select-filter filter-on'
                          : 'select-filter'
                      }
                      name='selectedFilterObj.kskapiRunning'
                      value={selectedFilterObj.kskapiRunning}
                      onChange={this.handleInputChange}
                    >
                      {serviceKskapiSelectOptions.map((item) => (
                        <option key={item.key} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                    <select
                      style={{ opacity: filterSelected ? '0.4' : 1 }}
                      disabled={filterSelected}
                      className={
                        shouldFilterByServiceCafeapiRunning
                          ? 'select-filter filter-on'
                          : 'select-filter'
                      }
                      name='selectedFilterObj.cafeapiRunning'
                      value={selectedFilterObj.cafeapiRunning}
                      onChange={this.handleInputChange}
                    >
                      {serviceCafeapiSelectOptions.map((item) => (
                        <option key={item.key} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                    <select
                      style={{ opacity: filterSelected ? '0.4' : 1 }}
                      disabled={filterSelected}
                      className={
                        shouldFilterByServiceHeatwaveRunning
                          ? 'select-filter filter-on'
                          : 'select-filter'
                      }
                      name='selectedFilterObj.heatwaveRunning'
                      value={selectedFilterObj.heatwaveRunning}
                      onChange={this.handleInputChange}
                    >
                      {serviceHeatwaveSelectOptions.map((item) => (
                        <option key={item.key} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
            </div>
          )}

          <Table
            rowsCount={dataList.length}
            rowHeight={50}
            headerHeight={50}
            width={tableWidth}
            height={tableHeight}
            rowClassNameGetter={this.getRowClassNameGetter.bind(
              this,
              dataList,
              selectedHostInfoList
            )}
            onRowClick={this.handleRowClick.bind(this, dataList)}
            {...tableProps}
            {...this.props}
          >
            <Column
              header={<Cell>#</Cell>}
              cell={(props) => (
                <Cell {...props}>
                  <span style={{ fontSize: 10 }}>{props.rowIndex + 1}</span>
                </Cell>
              )}
              fixed={true}
              width={46}
              align='center'
            />
            <Column
              columnKey='ip'
              header={
                <SortHeaderCell onSortChange={this.handleSortChange} sortDir={columnSortDirs.ip}>
                  IP Addr TeamViewer
                </SortHeaderCell>
              }
              cell={(props) => {
                let host = dataList[props.rowIndex];
                let opacity = Util.calcHostInfoRowOpacity(host);
                return (
                  <Cell
                    {...props}
                    style={{ cursor: 'pointer', color: 'blue', opacity }}
                    onClick={this.handleViewHostInfo.bind(this, host)}
                  >
                    {host.ip || host.id}
                    <br />
                    <span style={{ fontSize: 10 }}>{host.teamviewerClientID}</span>
                  </Cell>
                );
              }}
              fixed={true}
              width={100}
              align='right'
            />

            <Column
              columnKey='kioskName'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.kioskName}
                >
                  Kiosk | Type
                </SortHeaderCell>
              }
              cell={(props) => {
                let host = dataList[props.rowIndex];
                let opacity = Util.calcHostInfoRowOpacity(host);
                return (
                  <Cell {...props} className='main-cell' style={{ opacity }} title={host.kioskName}>
                    {host.kioskName} <br />
                    <span
                      style={{
                        fontSize: 10,
                        textOverflow: 'ellipsis',
                        width: 135,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                      }}
                    >
                      {host.kioskType}
                    </span>
                  </Cell>
                );
              }}
              fixed={true}
              width={115}
              align='right'
            />

            <Column
              columnKey='orgName'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.orgName}
                >
                  Org | Location
                </SortHeaderCell>
              }
              cell={(props) => {
                let host = dataList[props.rowIndex];
                let opacity = Util.calcHostInfoRowOpacity(host);
                return (
                  <Cell
                    {...props}
                    className='main-cell'
                    style={{ opacity }}
                    title={host.orgName + ' | ' + host.locationName}
                  >
                    {host.orgName} <br />
                    <span
                      style={{
                        fontSize: 11,
                        textOverflow: 'ellipsis',
                        width: 135,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                      }}
                    >
                      {host.locationName}
                    </span>
                  </Cell>
                );
              }}
              fixed={true}
              width={195}
            />

            {tableView === OTHER ? (
              <Column
                columnKey='sosdbGoLive'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.sosdbGoLive}
                  >
                    GoLive
                  </SortHeaderCell>
                }
                cell={<TextCell dataList={dataList} field='sosdbGoLive' isYN={true} />}
                fixed={true}
                width={45}
              />
            ) : null}

            {tableView === APP_STATUS || tableView === OS ? (
              <Column
                columnKey='kioskHW'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.kioskHW}
                  >
                    HW
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ opacity: opacity }}>
                      {host.kioskHW}
                    </Cell>
                  );
                }}
                fixed={true}
                width={40}
              />
            ) : null}

            {tableView === OS ? (
              <Column
                columnKey='optConnectSerialNumber'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.optConnectSerialNumber}
                  >
                    OptConnect SN
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ opacity: opacity }}>
                      {host.optConnectSerialNumber ? host.optConnectSerialNumber : '-'}
                    </Cell>
                  );
                }}
                fixed={true}
                width={40}
              />
            ) : null}

            {tableView === OTHER ? (
              <Column
                columnKey='sfecfgServices'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 11 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.sfecfgServices}
                  >
                    Service Type
                  </SortHeaderCell>
                }
                cell={
                  <TextCell
                    dataList={dataList}
                    field='sfecfgServices'
                    hoverTextField='sfecfgServicesText'
                  />
                }
                fixed={true}
                width={50}
              />
            ) : null}

            {tableView === OTHER ? (
              <Column
                columnKey='hasSosdbKiosk'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.hasSosdbKiosk}
                  >
                    In sosdb
                  </SortHeaderCell>
                }
                cell={<TextCell dataList={dataList} field='hasSosdbKiosk' isYN={true} />}
                fixed={true}
                width={40}
                align='right'
              />
            ) : null}

            {tableView === OTHER ? (
              <Column
                columnKey='fingerprint'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.fingerprint}
                  >
                    ServerUrl | OS
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.kskcfgServerUrl || '-'} <br />
                      {host.os}
                    </Cell>
                  );
                }}
                fixed={true}
                width={185}
                align='left'
              />
            ) : null}

            {tableView === APP_VERSION ? (
              <Column
                columnKey='sosdbDeploymentTime'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.sosdbDeploymentTime}
                  >
                    Update Time (HH:mm)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 11, fontWeight: 500, opacity }}>
                      {host.sosdbDeploymentTime}
                    </Cell>
                  );
                }}
                fixed={true}
                width={50}
              />
            ) : null}

            {tableView === APP_VERSION ? (
              <Column
                columnKey='sosdbDeploymentSet'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.sosdbDeploymentSet}
                  >
                    Deployment Set (desired)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 11, fontWeight: 500, opacity }}>
                      {host.sosdbDeploymentSet}
                    </Cell>
                  );
                }}
                fixed={true}
                width={80}
              />
            ) : null}

            {tableView === APP_VERSION ? (
              <Column
                columnKey='kvsNames'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.kvsNames}
                    style={{ fontSize: 10 }}
                  >
                    Deployment Set (actual)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  let kvsNames = host.kvsNames || '';
                  let color = kvsNames.indexOf(host.sosdbDeploymentSet) === -1 ? 'red' : 'inherit';
                  return (
                    <Cell
                      {...props}
                      style={{ opacity: opacity, fontSize: 11 }}
                      title={host.kvsNames}
                    >
                      <span style={{ color: color }}>{host.kvsNames}</span>
                    </Cell>
                  );
                }}
                fixed={true}
                width={85}
              />
            ) : null}

            {tableView === APP_VERSION ? (
              <Column
                columnKey='printapiVersion'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.printapiVersion}
                  >
                    printapi
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let running = host.printapiRunning;
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell
                      {...props}
                      className='version-cell'
                      style={{ color: running ? 'green' : 'red', opacity: opacity }}
                      title={running ? 'Running' : 'Not Running'}
                    >
                      {host.printapiVersion}
                    </Cell>
                  );
                }}
                fixed={true}
                width={70}
              />
            ) : null}

            {tableView === APP_VERSION ? (
              <Column
                columnKey='payapiVersion'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.payapiVersion}
                  >
                    payapi
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let running = host.payapiRunning;
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell
                      {...props}
                      className='version-cell'
                      style={{ color: running ? 'green' : 'red', opacity: opacity }}
                      title={running ? 'Running' : 'Not Running'}
                    >
                      {host.payapiVersion}
                    </Cell>
                  );
                }}
                fixed={true}
                width={70}
              />
            ) : null}

            {tableView === APP_VERSION ? (
              <Column
                columnKey='capuiVersion'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.capuiVersion}
                  >
                    capui
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let running = host.capuiRunning;
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell
                      {...props}
                      className='version-cell'
                      style={{ color: running ? 'green' : 'red', opacity: opacity }}
                      title={running ? 'Running' : 'Not Running'}
                    >
                      {host.capuiVersion}
                    </Cell>
                  );
                }}
                fixed={true}
                width={70}
              />
            ) : null}

            {tableView === APP_VERSION ? (
              <Column
                columnKey='kioskprobeVersion'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.kioskprobeVersion}
                  >
                    kiosk-probe
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let running = host.kioskprobeRunning;
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell
                      {...props}
                      className='version-cell'
                      style={{ color: running ? 'green' : 'red', opacity: opacity }}
                      title={running ? 'Running' : 'Not Running'}
                    >
                      {host.kioskprobeVersion}
                    </Cell>
                  );
                }}
                fixed={true}
                width={70}
              />
            ) : null}

            {tableView === APP_VERSION ? (
              <Column
                columnKey='kskapiVersion'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.kskapiVersion}
                  >
                    kskapi
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let running = host.kskapiRunning;
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell
                      {...props}
                      className='version-cell'
                      style={{ color: running ? 'green' : 'red', opacity: opacity }}
                      title={running ? 'Running' : 'Not Running'}
                    >
                      {host.kskapiVersion}
                    </Cell>
                  );
                }}
                fixed={true}
                width={70}
              />
            ) : null}

            {tableView === APP_VERSION ? (
              <Column
                columnKey='cafeapiVersion'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.cafeapiVersion}
                  >
                    cafeapi
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let running = host.cafeapiRunning;
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell
                      {...props}
                      className='version-cell'
                      style={{ color: running ? 'green' : 'red', opacity: opacity }}
                      title={running ? 'Running' : 'Not Running'}
                    >
                      {host.cafeapiVersion}
                    </Cell>
                  );
                }}
                fixed={true}
                width={70}
              />
            ) : null}

            {tableView === APP_VERSION ? (
              <Column
                columnKey='heatwaveVersion'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.heatwaveVersion}
                  >
                    heatwave
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let running = host.heatwaveRunning;
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell
                      {...props}
                      className='version-cell'
                      style={{ color: running ? 'green' : 'red', opacity: opacity }}
                      title={running ? 'Running' : 'Not Running'}
                    >
                      {host.heatwaveVersion}
                    </Cell>
                  );
                }}
                fixed={true}
                width={70}
              />
            ) : null}

            {tableView === OTHER ? (
              <Column
                columnKey='linuxdashVer'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.linuxdashVer}
                  >
                    linuxdash
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let running = true; // always running since it is the once sending info
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell
                      {...props}
                      className='version-cell'
                      style={{ color: running ? 'green' : 'red', opacity: opacity }}
                      title={running ? 'Running' : 'Not Running'}
                    >
                      {host.linuxdashVer}
                    </Cell>
                  );
                }}
                fixed={true}
                width={55}
              />
            ) : null}

            {tableView === KIOSK_PERIPHERAL ? (
              <Column
                columnKey='touchscreenType'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.touchscreenType}
                  >
                    Touchscreen
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ opacity: opacity, fontSize: 10 }}>
                      {host.touchscreenType}
                      <br />
                      <span style={{ fontSize: 10 }}>
                        {host.touchscreenType ? host.kioskTouchDriver : ''}
                      </span>
                    </Cell>
                  );
                }}
                fixed={true}
                width={90}
              />
            ) : null}

            {tableView === KIOSK_PERIPHERAL ? (
              <Column
                columnKey='usbBarcodeScanner'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.usbBarcodeScanner}
                  >
                    Barcode Scanner (USB)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.usbBarcodeScanner}
                    </Cell>
                  );
                }}
                fixed={true}
                width={70}
              />
            ) : null}

            {tableView === KIOSK_PERIPHERAL ? (
              <Column
                columnKey='usbMSR'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.usbMSR}
                  >
                    MSR (USB)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.usbMSR}
                    </Cell>
                  );
                }}
                fixed={true}
                width={60}
              />
            ) : null}

            {tableView === KIOSK_PERIPHERAL ? (
              <Column
                columnKey='usbPrinter'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.usbPrinter}
                  >
                    Printer (USB)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.usbPrinter}
                    </Cell>
                  );
                }}
                fixed={true}
                width={60}
              />
            ) : null}

            {tableView === KIOSK_PERIPHERAL ? (
              <Column
                columnKey='usbScale'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.usbScale}
                  >
                    Scale (USB)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.usbScale}
                    </Cell>
                  );
                }}
                fixed={true}
                width={65}
              />
            ) : null}

            {tableView === KIOSK_PERIPHERAL ? (
              <Column
                columnKey='usbFingerprintReader'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.usbFingerprintReader}
                  >
                    Fingerprint Reader (USB)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.usbFingerprintReader}
                    </Cell>
                  );
                }}
                fixed={true}
                width={65}
              />
            ) : null}

            {tableView === KIOSK_PERIPHERAL ? (
              <Column
                columnKey='usbWebCam'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.usbWebCam}
                  >
                    WebCam (USB)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.usbWebCam}
                    </Cell>
                  );
                }}
                fixed={true}
                width={60}
              />
            ) : null}

            {tableView === KIOSK_PERIPHERAL ? (
              <Column
                columnKey='usbBillAcceptor'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.usbBillAcceptor}
                  >
                    Bill Acceptor (USB)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.usbBillAcceptor}
                    </Cell>
                  );
                }}
                fixed={true}
                width={50}
              />
            ) : null}

            {tableView === KIOSK_PERIPHERAL ? (
              <Column
                columnKey='usbCoinDispenser'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.usbCoinDispenser}
                  >
                    Coin Dispenser (USB)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.usbCoinDispenser}
                    </Cell>
                  );
                }}
                fixed={true}
                width={55}
              />
            ) : null}

            {tableView === KIOSK_PERIPHERAL ? (
              <Column
                columnKey='usbCashlessReader'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.usbCashlessReader}
                  >
                    Cashless Reader (USB)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.usbCashlessReader}
                    </Cell>
                  );
                }}
                fixed={true}
                width={50}
              />
            ) : null}

            {tableView === OTI ? (
              <Column
                columnKey='otiFirmware'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.otiFirmware}
                  >
                    OTI Firmware
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.otiFirmware}
                    </Cell>
                  );
                }}
                fixed={true}
                width={150}
              />
            ) : null}

            {tableView === OTI ? (
              <Column
                columnKey='otiConfig'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.otiConfig}
                  >
                    OTI Config
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.otiConfig}
                    </Cell>
                  );
                }}
                fixed={true}
                width={120}
              />
            ) : null}

            {tableView === KIOSK_PERIPHERAL ? (
              <Column
                columnKey='usbTemperatureSensor'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.usbTemperatureSensor}
                  >
                    Temp Sensor (USB)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.usbTemperatureSensor}
                    </Cell>
                  );
                }}
                fixed={true}
                width={60}
              />
            ) : null}

            {tableView === KIOSK_PERIPHERAL ? (
              <Column
                columnKey='usbCustomerLineDisplay'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.usbCustomerLineDisplay}
                  >
                    Line Display (USB)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.usbCustomerLineDisplay}
                    </Cell>
                  );
                }}
                fixed={true}
                width={55}
              />
            ) : null}

            {tableView === APP_STATUS ? (
              <Column
                columnKey='sosdbKioskStatus'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.sosdbKioskStatus}
                  >
                    Status (mtr)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  let online = /ONLINE/i.test(host.sosdbKioskStatus);
                  let offline = /OFFLINE/i.test(host.sosdbKioskStatus);
                  let local = /LOCAL/i.test(host.sosdbKioskStatus);
                  let monitorEnabled = host.sosdbMonitor > 0;
                  if (!monitorEnabled) {
                    return (
                      <Cell
                        {...props}
                        style={{ textAlign: 'center', opacity }}
                        title='Monitor Disabled'
                      >
                        <i style={{ color: 'red' }} className='fa fa-fw fa-times' />
                      </Cell>
                    );
                  }
                  return (
                    <Cell
                      {...props}
                      style={{ textAlign: 'center', opacity }}
                      title={host.sosdbKioskStatus}
                    >
                      {online && <i style={{ color: 'green' }} className='fa fa-fw fa-arrow-up' />}
                      {offline && <i style={{ color: 'red' }} className='fa fa-fw fa-arrow-down' />}
                      {local && <span style={{ color: 'red' }}>L</span>}
                      {!online && !offline && !local && (
                        <i style={{ color: 'gray' }} className='fa fa-fw fa-minus' />
                      )}
                    </Cell>
                  );
                }}
                fixed={true}
                width={40}
              />
            ) : null}

            {tableView === APP_STATUS ? (
              <Column
                columnKey='kskdbTransqueCount'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.kskdbTransqueCount}
                  >
                    TransQue Count
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props}>
                      {host.kskdbTransqueCount === 0 ? (
                        <span style={{ color: 'green', opacity: opacity }}>
                          {host.kskdbTransqueCount}
                        </span>
                      ) : (
                        <span style={{ color: 'red', opacity: opacity }}>
                          {host.kskdbTransqueCount}
                        </span>
                      )}
                    </Cell>
                  );
                }}
                fixed={true}
                width={55}
              />
            ) : null}

            {tableView === APP_STATUS ? (
              <Column
                columnKey='kskapiMode'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.kskapiMode}
                  >
                    kskapi Mode
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props}>
                      {host.kskapiMode === 'online' ? (
                        <span style={{ color: 'green', opacity: opacity }}>{host.kskapiMode}</span>
                      ) : (
                        <span style={{ color: 'red', opacity: opacity }}>{host.kskapiMode}</span>
                      )}
                    </Cell>
                  );
                }}
                fixed={true}
                width={50}
              />
            ) : null}

            {tableView === CONFIG_CHECK ? (
              <Column
                columnKey='payapiCCMode'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.payapiCCMode}
                  >
                    payapi Mode
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 11 }}>
                      {host.payapiCCMode === 'prod' ? (
                        <span style={{ color: 'green', opacity: opacity }}>
                          {host.payapiCCMode}
                        </span>
                      ) : (
                        <span style={{ color: 'red', opacity: opacity }}>{host.payapiCCMode}</span>
                      )}
                    </Cell>
                  );
                }}
                fixed={true}
                width={55}
              />
            ) : null}

            {tableView === APP_STATUS ? (
              <Column
                columnKey='payapiProcessorsStatus'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.payapiProcessorsStatus}
                  >
                    payapi Processors
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 12 }}>
                      {/local/i.test(host.payapiProcessorsStatus) ? (
                        <span style={{ color: 'red', opacity: opacity }}>
                          {host.payapiProcessorsStatus}
                        </span>
                      ) : (
                        <span style={{ color: 'green', opacity: opacity }}>
                          {host.payapiProcessorsStatus}
                        </span>
                      )}
                    </Cell>
                  );
                }}
                fixed={true}
                width={165}
              />
            ) : null}

            {tableView === APP_STATUS ? (
              <Column
                columnKey='aprivaPortCheck'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.aprivaPortCheck}
                  >
                    Apriva Port
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props}>
                      {host.aprivaPortCheck === 'succeeded' ? (
                        <span style={{ color: 'green', opacity: opacity }}>ok</span>
                      ) : (
                        <span style={{ color: 'red', opacity: opacity }}>
                          {host.aprivaPortCheck}
                        </span>
                      )}
                    </Cell>
                  );
                }}
                fixed={true}
                width={40}
              />
            ) : null}

            {tableView === APP_STATUS ? (
              <Column
                columnKey='kskdbCCLocalCount'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.kskdbCCLocalCount}
                  >
                    ccLocal Count
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} title={host.kskdbCCLocalLocalDate}>
                      {host.kskdbCCLocalCount === 0 ? (
                        <span style={{ color: 'green', opacity: opacity }}>
                          {host.kskdbCCLocalCount}
                        </span>
                      ) : (
                        <div style={{ display: 'inline', padding: 0, margin: 0 }}>
                          <span style={{ color: 'red', opacity: opacity }}>
                            {host.kskdbCCLocalCount}
                          </span>
                          <br />
                          <span style={{ opacity: opacity, fontSize: 11 }}>
                            {host.kskdbCCLocalXAgo}
                          </span>
                        </div>
                      )}
                    </Cell>
                  );
                }}
                fixed={true}
                width={130}
              />
            ) : null}

            {tableView === APP_STATUS ? (
              <Column
                columnKey='kskdbCCQuarantineCount'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.kskdbCCQuarantineCount}
                  >
                    ccQuarantine Count
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} title={host.kskdbCCQuarantineLocalDate}>
                      {host.kskdbCCQuarantineCount === 0 ? (
                        <span style={{ color: 'green', opacity: opacity }}>
                          {host.kskdbCCQuarantineCount}
                        </span>
                      ) : (
                        <div style={{ display: 'inline' }}>
                          <span style={{ color: 'red', opacity: opacity }}>
                            {host.kskdbCCQuarantineCount}
                          </span>
                          <br />
                          <span style={{ opacity: opacity, fontSize: 11 }}>
                            {host.kskdbCCQuarantineXAgo}
                          </span>
                        </div>
                      )}
                    </Cell>
                  );
                }}
                fixed={true}
                width={80}
              />
            ) : null}

            {tableView === OTHER ? (
              <Column
                columnKey='kskdbSahCount'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.kskdbSahCount}
                    style={{ fontSize: 10 }}
                  >
                    # of Sales
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ textAlign: 'right', opacity: opacity, fontSize: 10 }}>
                      {host.kskdbSahCount}
                    </Cell>
                  );
                }}
                fixed={true}
                width={55}
              />
            ) : null}

            {tableView === OTHER ? (
              <Column
                columnKey='kskdbSapCount'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.kskdbSapCount}
                    style={{ fontSize: 10 }}
                  >
                    # of Payments
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ textAlign: 'right', opacity: opacity, fontSize: 10 }}>
                      {host.kskdbSapCount}
                    </Cell>
                  );
                }}
                fixed={true}
                width={55}
              />
            ) : null}

            {tableView === APP_STATUS ? (
              <Column
                columnKey='cupsPendingPrintJobs'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.cupsPendingPrintJobs}
                  >
                    Print Jobs
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props}>
                      {host.cupsPendingPrintJobs > 1 ? (
                        <span style={{ color: 'red', opacity: opacity }}>
                          {host.cupsPendingPrintJobs}
                        </span>
                      ) : (
                        <span style={{ color: 'green', opacity: opacity }}>
                          {host.cupsPendingPrintJobs}
                        </span>
                      )}
                    </Cell>
                  );
                }}
                fixed={true}
                width={40}
              />
            ) : null}

            {tableView === APP_STATUS ? (
              <Column
                columnKey='sosdbLastTransDate'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.sosdbLastTransDate}
                  >
                    Last TransDate
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  let lastTransColor = '';
                  if (Util.moreThanXHoursAgo(host.sosdbLastTransDate, 12)) {
                    lastTransColor = 'orange';
                  }
                  if (Util.moreThanXHoursAgo(host.sosdbLastTransDate, 24)) {
                    lastTransColor = 'darkred';
                  }
                  return (
                    <Cell {...props} style={{ fontSize: 11, opacity }}>
                      <span style={{ color: lastTransColor }} title={host.sosdbLastFullSync}>
                        {host.sosdbLastTranDateXAgo}
                      </span>
                    </Cell>
                  );
                }}
                fixed={true}
                width={80}
              />
            ) : null}

            {tableView === APP_STATUS ? (
              <Column
                columnKey='sosdbLastFullSync'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.sosdbLastFullSync}
                  >
                    Last Full Sync
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  let lastSyncColor = '';
                  if (Util.moreThanXHoursAgo(host.sosdbLastFullSync, 24)) {
                    lastSyncColor = 'orange';
                  }
                  if (Util.moreThanXHoursAgo(host.sosdbLastFullSync, 48)) {
                    lastSyncColor = 'darkred';
                  }
                  return (
                    <Cell {...props} style={{ fontSize: 11, opacity }}>
                      <span style={{ color: lastSyncColor }} title={host.sosdbLastFullSync}>
                        {host.sosdbLastFullSyncXAgo}
                      </span>
                    </Cell>
                  );
                }}
                fixed={true}
                width={80}
              />
            ) : null}

            {tableView === CONFIG_CHECK ? (
              <Column
                columnKey='kskSameName'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.kskSameName}
                  >
                    Kiosk Name (kskdb vs. capui)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  let title1 = `kiosk/kskdb: ${host.kioskName}`;
                  let title2 = `capui/settings.json device: ${host.capuiDeviceName}`;
                  return (
                    <Cell {...props} style={{ textAlign: 'right', fontSize: 11 }}>
                      {/yes/i.test(host.kskSameName) ? (
                        <span
                          style={{ color: 'green', opacity: opacity }}
                          title={title1 + ' == ' + title2}
                        >
                          {host.kioskName}
                        </span>
                      ) : (
                        <span
                          style={{ color: 'red', opacity: opacity }}
                          title={title1 + ' != ' + title2}
                        >
                          {host.kioskName} <br />
                          {host.capuiDeviceName}
                        </span>
                      )}
                    </Cell>
                  );
                }}
                fixed={true}
                width={100}
              />
            ) : null}

            {tableView === CONFIG_CHECK ? (
              <Column
                columnKey='kskSameLocName'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.kskSameLocName}
                  >
                    Location Name (kskdb vs. ADM)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  let title1 = `kiosk/kskdb: ${host.locationName}`;
                  let title2 = `ADM/sosodb: ${host.sosdbLocName}`;
                  return (
                    <Cell {...props} style={{ textAlign: 'right', fontSize: 11 }}>
                      {/yes/i.test(host.kskSameLocName) ? (
                        <span
                          style={{ color: 'green', opacity: opacity }}
                          title={title1 + ' == ' + title2}
                        >
                          {host.locationName}
                        </span>
                      ) : (
                        <span
                          style={{ color: 'red', opacity: opacity }}
                          title={title1 + ' != ' + title2}
                        >
                          {host.locationName} <br />
                          {host.sosdbLocName}
                        </span>
                      )}
                    </Cell>
                  );
                }}
                fixed={true}
                width={210}
              />
            ) : null}

            {tableView === CONFIG_CHECK ? (
              <Column
                columnKey='kskSameOrgName'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.kskSameOrgName}
                  >
                    Org Name (kskdb vs. ADM)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  let title1 = `kiosk/kskdb: ${host.orgName}`;
                  let title2 = `ADM/sosdb: ${host.sosdbOrgName}`;
                  return (
                    <Cell {...props} style={{ textAlign: 'right', fontSize: 11 }}>
                      {/yes/i.test(host.kskSameOrgName) ? (
                        <span
                          style={{ color: 'green', opacity: opacity }}
                          title={title1 + ' == ' + title2}
                        >
                          {host.orgName}
                        </span>
                      ) : (
                        <span
                          style={{ color: 'red', opacity: opacity }}
                          title={title1 + ' != ' + title2}
                        >
                          {host.orgName} <br />
                          {host.sosdbOrgName}
                        </span>
                      )}
                    </Cell>
                  );
                }}
                fixed={true}
                width={155}
              />
            ) : null}

            {tableView === CONFIG_CHECK ? (
              <Column
                columnKey='kskSameTimezone'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.kskSameTimezone}
                  >
                    Timezone (kskdb vs. actual)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  let title1 = `kiosk/kskdb: ${host.sosdbTimezoneLong} ${host.sosdbTimezoneOffset}`;
                  let title2 = `actual/machine: ${host.timezoneLong} ${host.timezoneOffset}`;
                  return (
                    <Cell {...props} style={{ textAlign: 'right', fontSize: 10 }}>
                      {/yes/i.test(host.kskSameTimezone) ? (
                        <span
                          style={{ color: 'green', opacity: opacity }}
                          title={title1 + ' == ' + title2}
                        >
                          {host.sosdbTimezoneLong}
                        </span>
                      ) : (
                        <span
                          style={{ color: 'red', opacity: opacity }}
                          title={title1 + ' != ' + title2}
                        >
                          {host.sosdbTimezoneLong} <br />
                          {host.timezoneLong}
                        </span>
                      )}
                    </Cell>
                  );
                }}
                fixed={true}
                width={120}
              />
            ) : null}

            {tableView === CONFIG_CHECK ? (
              <Column
                columnKey='kskSameTouchAxis'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.kskSameTouchAxis}
                  >
                    Touch Axis (current vs. calibrated) for V5
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  let title1 = `current: ${host.currentTouchAxis}`;
                  let title2 = `calibrated: ${host.calibratedTouchAxis}`;
                  return (
                    <Cell {...props} style={{ textAlign: 'right', fontSize: 11 }}>
                      {/yes/i.test(host.kskSameTouchAxis) ? (
                        <span
                          style={{ color: 'green', opacity: opacity }}
                          title={title1 + ' == ' + title2}
                        >
                          {host.currentTouchAxis}
                        </span>
                      ) : (
                        <span
                          style={{ color: 'red', opacity: opacity }}
                          title={title1 + ' != ' + title2}
                        >
                          {host.currentTouchAxis} <br />
                          {host.calibratedTouchAxis}
                        </span>
                      )}
                    </Cell>
                  );
                }}
                fixed={true}
                width={110}
              />
            ) : null}

            {tableView === OTHER ? (
              <Column
                columnKey='kskdbx'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.kskdbx}
                  >
                    ksk dbx
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ opacity: opacity }}>
                      {host.kskdbx}
                    </Cell>
                  );
                }}
                fixed={true}
                width={40}
              />
            ) : null}

            {tableView === OTHER ? (
              <Column
                columnKey='salesdbx'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.salesdbx}
                  >
                    sales dbx
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ opacity: opacity }}>
                      {host.salesdbx}
                    </Cell>
                  );
                }}
                fixed={true}
                width={40}
              />
            ) : null}

            {tableView === OTHER ? (
              <Column
                columnKey='ccdbx'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.ccdbx}
                  >
                    cc dbx
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ opacity: opacity }}>
                      {host.ccdbx}
                    </Cell>
                  );
                }}
                fixed={true}
                width={40}
              />
            ) : null}

            {tableView === OTHER ? (
              <Column
                columnKey='kioskISOVersion'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.kioskISOVersion}
                  >
                    Kiosk ISO | MacAddress
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.kioskISOVersion || '-'} <br />
                      {host.macAddress}
                    </Cell>
                  );
                }}
                fixed={true}
                width={120}
                align='left'
              />
            ) : null}

            {tableView === APP_VERSION ? (
              <Column
                columnKey='sosdbTag'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.sosdbTag}
                  >
                    Tag
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let noTag = _.isEmpty(host.sosdbTag);
                  let prodTest = host.sosdbTag === KIOSK_TAG.PROD_TEST;
                  let checkBeforeUpdate = host.sosdbTag === KIOSK_TAG.CHECK_BEFORE_UPDATE;
                  let earlyUpdate = host.sosdbTag === KIOSK_TAG.EARLY_UPDATE;
                  let tempBeta = host.sosdbTag === KIOSK_TAG.TEMP_BETA;
                  let doNotUpdate = host.sosdbTag === KIOSK_TAG.DO_NOT_UPDATE;
                  let custom =
                    !noTag &&
                    !prodTest &&
                    !checkBeforeUpdate &&
                    !earlyUpdate &&
                    !tempBeta &&
                    !doNotUpdate;

                  // Also see KioskTagging for icon and color for tag
                  return (
                    <Cell {...props} style={{ fontSize: 14 }}>
                      {noTag && <span className='fa fa-fw fa-tag color-aux' title='No Tag' />}
                      {prodTest && (
                        <span className='fa fa-fw fa-tag color-success' title={host.sosdbTag} />
                      )}
                      {checkBeforeUpdate && (
                        <span className='fa fa-fw fa-tag color-primary' title={host.sosdbTag} />
                      )}
                      {earlyUpdate && (
                        <span className='fa fa-fw fa-tag color-accent' title={host.sosdbTag} />
                      )}
                      {tempBeta && (
                        <span className='fa fa-fw fa-tag color-deepskyblue' title={host.sosdbTag} />
                      )}
                      {doNotUpdate && (
                        <span className='fa fa-fw fa-tag color-danger' title={host.sosdbTag} />
                      )}
                      {custom && <span style={{ fontSize: 10 }}>{host.sosdbTag}</span>}
                    </Cell>
                  );
                }}
                fixed={true}
                width={35}
              />
            ) : null}

            {tableView === KIOSK_STATUS ? (
              <Column
                columnKey='timezone'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.timezone}
                  >
                    TimeZone
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 12, opacity: opacity }}>
                      {host.timezone}
                    </Cell>
                  );
                }}
                fixed={true}
                width={90}
                align='right'
              />
            ) : null}

            {tableView === KIOSK_STATUS ? (
              <Column
                columnKey='cpu1MinLoadAvgPercent'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    title='CPU Load Average 1 Minute Percent'
                    sortDir={columnSortDirs.cpu1MinLoadAvgPercent}
                  >
                    CPU Load 1
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell
                      {...props}
                      style={{
                        fontSize: 12,
                        opacity: opacity,
                        color: Util.calcLoadAvgColor(host.cpu1MinLoadAvgPercent),
                        fontWeight: 600,
                      }}
                    >
                      {host.cpu1MinLoadAvgPercent}
                    </Cell>
                  );
                }}
                fixed={true}
                width={60}
                align='right'
              />
            ) : null}

            {tableView === KIOSK_STATUS ? (
              <Column
                columnKey='cpu5MinLoadAvgPercent'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    title='CPU Load Average 5 Minutes Percent'
                    sortDir={columnSortDirs.cpu5MinLoadAvgPercent}
                  >
                    CPU Load 5
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell
                      {...props}
                      style={{
                        fontSize: 12,
                        opacity: opacity,
                        color: Util.calcLoadAvgColor(host.cpu5MinLoadAvgPercent),
                        fontWeight: 600,
                      }}
                    >
                      {host.cpu5MinLoadAvgPercent}
                    </Cell>
                  );
                }}
                fixed={true}
                width={60}
                align='right'
              />
            ) : null}

            {tableView === KIOSK_STATUS ? (
              <Column
                columnKey='cpu15MinLoadAvgPercent'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    title='CPU Load Average 15 Minutes Percent'
                    sortDir={columnSortDirs.cpu15MinLoadAvgPercent}
                  >
                    CPU Load 15
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell
                      {...props}
                      style={{
                        fontSize: 12,
                        opacity: opacity,
                        color: Util.calcLoadAvgColor(host.cpu15MinLoadAvgPercent),
                        fontWeight: 600,
                      }}
                    >
                      {host.cpu15MinLoadAvgPercent}
                    </Cell>
                  );
                }}
                fixed={true}
                width={60}
                align='right'
              />
            ) : null}

            {tableView === KIOSK_STATUS ? (
              <Column
                columnKey='memUsedPercent'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.memUsedPercent}
                  >
                    Mem Used
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell
                      {...props}
                      style={{
                        fontSize: 12,
                        opacity: opacity,
                        color: Util.calcMemUsageColor(host.memUsedPercent),
                        fontWeight: 600,
                      }}
                    >
                      {host.memUsedPercent ? host.memUsedPercent + '%' : ''}
                    </Cell>
                  );
                }}
                fixed={true}
                width={60}
                align='right'
              />
            ) : null}

            {tableView === KIOSK_STATUS ? (
              <Column
                columnKey='diskUsedPercent'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.diskUsedPercent}
                  >
                    Disk Used
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell
                      {...props}
                      style={{
                        fontSize: 12,
                        opacity: opacity,
                        color: Util.calcDiskUsageColor(host.diskUsedPercent),
                        fontWeight: 600,
                      }}
                    >
                      {host.diskUsedPercent ? host.diskUsedPercent + '%' : ''}
                    </Cell>
                  );
                }}
                fixed={true}
                width={60}
                align='right'
              />
            ) : null}

            {tableView === KIOSK_STATUS ? (
              <Column
                columnKey='diskTotal'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 11 }}
                    sortDir={columnSortDirs.diskTotal}
                  >
                    Disk Total
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 11, opacity: opacity }}>
                      {host.diskTotal}
                    </Cell>
                  );
                }}
                fixed={true}
                width={80}
                align='right'
              />
            ) : null}

            {tableView === KIOSK_STATUS || tableView === OS ? (
              <Column
                columnKey='upsince'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 11 }}
                    sortDir={columnSortDirs.upsince}
                  >
                    Uptime
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell
                      {...props}
                      style={{ fontSize: 11, opacity: opacity }}
                      title={'Up since ' + host.upsince}
                    >
                      {host.uptime}
                    </Cell>
                  );
                }}
                fixed={true}
                width={100}
                align='right'
              />
            ) : null}

            {tableView === KIOSK_STATUS ? (
              <Column
                columnKey='kioskprobeVersion'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.kioskprobeVersion}
                  >
                    Provisioner (Electron)
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let running = host.kioskprobeRunning;
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 11, opacity: opacity }}>
                      {host.kioskprobeVersion}
                    </Cell>
                  );
                }}
                fixed={true}
                width={70}
                align='right'
              />
            ) : null}

            {tableView === KIOSK_STATUS ? (
              <Column
                columnKey='kioskprobeRunning'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.kioskprobeRunning}
                  >
                    Provisioner Running?
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let running = host.kioskprobeRunning;
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell
                      {...props}
                      className='version-cell'
                      style={{ color: running ? 'green' : 'red', opacity: opacity }}
                      title={running ? 'Running' : 'Not Running'}
                    >
                      {String(running)}
                    </Cell>
                  );
                }}
                fixed={true}
                width={70}
                align='right'
              />
            ) : null}

            {tableView === OS && (
              <Column
                columnKey='os'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.os}
                  >
                    OS
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.os}
                    </Cell>
                  );
                }}
                fixed={true}
                width={120}
                align='left'
              />
            )}

            {tableView === OS && (
              <Column
                columnKey='lastSuccessfulPatchDateTime'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.lastSuccessfulPatchedDate}
                  >
                    Last Successful Patch Date & Time
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.lastSuccessfulPatchedDate != null
                        ? host.lastSuccessfulPatchedDate + ''
                        : 'N/A'}
                    </Cell>
                  );
                }}
                fixed={true}
                width={100}
                align='left'
              />
            )}

            {tableView === OS && (
              <Column
                columnKey='patchDateTime'
                header={
                  <SortHeaderCell
                    style={{ fontSize: 10 }}
                    onSortChange={this.handleSortChange}
                    sortDir={columnSortDirs.patchDateTime}
                  >
                    Scheduled Patch Date & Time
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell {...props} style={{ fontSize: 10, opacity: opacity }}>
                      {host.patchDateTime}
                    </Cell>
                  );
                }}
                fixed={true}
                width={120}
                align='left'
              />
            )}

            {tableView === OS ? (
              <Column
                columnKey='ciscoampVersion'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.ciscoampVersion}
                  >
                    cisco-amp
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let running = host.ciscoampRunning;
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell
                      {...props}
                      className='version-cell'
                      style={{ color: running ? 'green' : 'red', opacity: opacity }}
                      title={running ? 'Running' : 'Not Running'}
                    >
                      {host.ciscoampVersion}
                    </Cell>
                  );
                }}
                fixed={true}
                width={70}
              />
            ) : null}

            {tableView === OS ? (
              <Column
                columnKey='cortexAgentVersion'
                header={
                  <SortHeaderCell
                    onSortChange={this.handleSortChange}
                    style={{ fontSize: 10 }}
                    sortDir={columnSortDirs.cortexAgentVersion}
                  >
                    cortex-agent
                  </SortHeaderCell>
                }
                cell={(props) => {
                  let host = dataList[props.rowIndex];
                  let running = host.cortexAgentRunning;
                  let opacity = Util.calcHostInfoRowOpacity(host);
                  return (
                    <Cell
                      {...props}
                      className='version-cell'
                      style={{ color: running ? 'green' : 'red', opacity: opacity }}
                      title={running ? 'Installed' : 'Not Installed'}
                    >
                      {running
                        ? 'Installed with version: ' + host.cortexAgentVersion.substring(0, 14)
                        : 'Not Installed'}
                    </Cell>
                  );
                }}
                fixed={true}
                width={110}
              />
            ) : null}

            <Column
              columnKey='lastFetchedDateTime'
              header={
                <SortHeaderCell
                  style={{ fontSize: 10 }}
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.lastFetchedDateTime}
                >
                  Last DashBeat
                </SortHeaderCell>
              }
              cell={(props) => {
                let host = dataList[props.rowIndex];
                let opacity = Util.calcHostInfoRowOpacity(host);
                return (
                  <Cell {...props} style={{ fontSize: 11, opacity }}>
                    {host.isBadFetchStatus ? (
                      <span style={{ color: 'darkred' }} title={host.lastFetchedDateTime}>
                        {host.lastFetchedXAgo}
                      </span>
                    ) : (
                      <span style={{ color: '' }} title={host.lastFetchedDateTime}>
                        {host.lastFetchedXAgo}
                      </span>
                    )}
                  </Cell>
                );
              }}
              fixed={true}
              width={80}
            />

            {tableView !== APP_VERSION && (
              <Column
                header={<Cell> </Cell>}
                cell={(props) => {
                  let hostInfo = dataList[props.rowIndex];
                  return (
                    <Cell {...props}>
                      <div
                        style={{ display: 'inline-block', padding: 8 }}
                        onClick={this.handleRefreshIconClick.bind(this, hostInfo, ref)}
                      >
                        <i
                          style={{ fontSize: '150%', color: '#363841' }}
                          className='fa fa-refresh'
                          ref={(c) => (ref[getRefreshIconKey(hostInfo)] = c)}
                          title='Refresh'
                        />
                      </div>
                      {showDeleteIcon && (
                        <div
                          style={{ display: 'inline-block', padding: 8 }}
                          onClick={this.handleDeleteRow.bind(this, hostInfo, ref)}
                        >
                          <i
                            style={{ color: '#363841', fontSize: '150%' }}
                            className='fa fa-trash-o '
                            ref={(c) => (ref[getTrashIconKey(hostInfo)] = c)}
                            title='Delete'
                          />
                        </div>
                      )}
                    </Cell>
                  );
                }}
                fixed={true}
                width={showDeleteIcon ? 90 : 45}
              />
            )}
          </Table>
          <div className='pure-g' style={{ padding: '5px 0' }}>
            <div className='pure-u-2-5'>
              {hasFilter ? (
                <span>
                  Showing {dataList.length} entries (filtered from {size} total entries){' '}
                </span>
              ) : (
                <span>
                  Showing {dataList.length} of {size}
                </span>
              )}
            </div>
            <div className='pure-u-3-5' style={{ textAlign: 'right' }}>
              {isSuperRole && selectedHostInfoList.length > 0 && (
                <a
                  href='javascript:void(0)'
                  style={{ marginRight: '15px' }}
                  onClick={this.handleDeleteSelectedKiosks}
                >
                  <i className='fa fa-fw fa-trash-o' />
                  Delete
                </a>
              )}
              {isSuperRole && selectedHostInfoList.length > 0 && isProdKioskTable && (
                <a
                  href='javascript:void(0)'
                  style={{ marginRight: '15px' }}
                  onClick={this.handleUpdateDeploymentSet}
                >
                  <i className='fa fa-fw fa-building-o' />
                  Update Deployment Set
                </a>
              )}
              {isSuperRole && selectedHostInfoList.length > 0 && isProdKioskTable && (
                <a
                  href='javascript:void(0)'
                  style={{ marginRight: '15px' }}
                  onClick={this.handleTagSelectedKiosks}
                >
                  <i className='fa fa-fw fa-tag' />
                  Tag
                </a>
              )}
              {isSuperRole && selectedHostInfoList.length > 0 && (
                <a
                  href='javascript:void(0)'
                  style={{ marginRight: '15px' }}
                  onClick={this.handleUpdateSelectedKiosks}
                >
                  <i className='fa fa-fw fa-rocket' />
                  Update Kiosks
                </a>
              )}
              {isSuperRole && selectedHostInfoList.length > 0 && (
                <a
                  href='javascript:void(0)'
                  style={{ marginRight: '15px' }}
                  onClick={this.handleKioskPackageUpdate}
                >
                  <i className='fa fa-fw fa-gear' />
                  Schedule Package Updates
                </a>
              )}
              {isSuperRole && selectedHostInfoList.length > 0 && isProdKioskTable && (
                <a
                  href='javascript:void(0)'
                  style={{ marginRight: '15px' }}
                  onClick={this.handleBatchAction}
                >
                  <i className='fa fa-fw fa-list-alt' />
                  Batch Action
                </a>
              )}
              {selectedHostInfoList.length > 0 && (
                <a
                  href='javascript:void(0)'
                  className=''
                  onClick={Util.downloadCSV.bind(this, selectedHostInfoList, this.props.tableTitle)}
                >
                  <i className='fa fa-fw fa-cloud-download' />
                  Export selected to CSV
                </a>
              )}
            </div>

            <div className='pure-u-1-2'>
              {selectedHostInfoList.length > 0 && (
                <span style={{ marginLeft: 0 }}>Selected: {selectedHostInfoList.length}</span>
              )}
              {selectedHostInfoList.length > 0 && (
                <a
                  style={{ marginLeft: 20 }}
                  href='javascript:void(0)'
                  onClick={this.handleUnselectAll}
                >
                  Unselect All
                </a>
              )}
              {selectedHostInfoList.length > 0 && (
                <div style={{ display: 'inline-block', marginLeft: 20 }}>
                  <a
                    href='javascript:void(0)'
                    onClick={this.handleToggleBooleanState.bind(this, 'showSelectedOnly')}
                  >
                    show selected only:
                  </a>
                  <input
                    style={{ marginLeft: '5px' }}
                    name='showSelectedOnly'
                    type='checkbox'
                    checked={filterSelected}
                    onChange={this.handleInputChange}
                  />
                </div>
              )}

              {/*
              {hasFilter &&
              <pre className="pure-g pure-u-1" style={{fontSize: 11}}>
                Filters:{' '}
                {JSON.stringify(selectedFilterObj, undefined, 2)}
                {'\n'}
                {filterText ? 'Search Text: ' + filterText : ''}
              </pre>
              }
*/}
            </div>
            <div className='pure-u-1-2' style={{ textAlign: 'right' }}></div>
          </div>
        </div>
      </div>
    );
  }
}

export default KioskTable;



// WEBPACK FOOTER //
// ./src/components/KioskTable.js